// extracted by mini-css-extract-plugin
export var button = "add-plan-template-modal-module--button--XtOtz";
export var checkboxes = "add-plan-template-modal-module--checkboxes--SoTyf";
export var checkboxesLabel = "add-plan-template-modal-module--checkboxes-label--ibczk";
export var checkboxesRow = "add-plan-template-modal-module--checkboxes-row--hB5GO";
export var form = "add-plan-template-modal-module--form--0Xkq-";
export var input = "add-plan-template-modal-module--input--YfyRt";
export var loader = "add-plan-template-modal-module--loader--Lm6r1";
export var modal = "add-plan-template-modal-module--modal--ASOfO";
export var separator = "add-plan-template-modal-module--separator--M3XTg";